module.exports = __webpack_public_path__ + "img/yishi2.65dfab9c.jpg";